var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "_btn",
        class: ((_obj = {}),
        (_obj[_vm.tone] = _vm.tone),
        (_obj[_vm.appearance] = _vm.appearance),
        (_obj._busy = _vm.busy),
        _obj),
        attrs: {
          href: _vm._href,
          id: _vm.id,
          inert: _vm.inert,
          tabindex: _vm.inert ? -1 : _vm.tabindex
        },
        on: {
          dragstart: function($event) {
            $event.preventDefault()
          }
        }
      },
      _vm.__on
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }